module.exports = __webpack_public_path__ + "img/tower-control.fee26890.svg";